import { AbilityClaim, GetClaimArgs, LinkClaimArgs } from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../backend/functions'

export const linkClaim = httpsCallable<LinkClaimArgs>(functions, 'linkClaim')
export const submitNewClaim = httpsCallable(functions, 'submitNewClaim')
export const getClaim = httpsCallable<GetClaimArgs, AbilityClaim>(functions, 'getClaim')
